module.exports = __webpack_public_path__ + "static/media/datepicker3.bf5c845f.svg";